import React from 'react';

export default ({ fields }) => (
  <span className='related-links'>
    <span className="display-id-wrapper">
      <span className="fa fa-fw fa-institution mr-2" />
      <span className="display-id">
        {fields.shortcode}
      </span>
    </span>
    <span className="subject">
      {fields.name}
    </span>
  </span>
);
